import "./ProductosPage.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { ProductoResponse } from "../../../shared/response/catalogos/ProductoResponse";
import { ProductoListService } from "../../../shared/services/catalogos/ProductoListService";

export class ProductosPage extends BasePageComponent {
  private _all:      ProductoResponse[] = [];
  private _filtered: ProductoResponse[] = [];

  public getAppRoute(): string { return "/admin/catalogos/productos"; }
  public getPageTitle(): string | null { return "Productos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page prod-page";

    pageContent.innerHTML = `
      <div class="prod-content">

        <div class="prod-pg-hd">
          <div>
            <div class="prod-pg-ey">Catálogo</div>
            <div class="prod-pg-t">Productos</div>
            <div class="prod-pg-s">Insumos y agroquímicos registrados</div>
          </div>
        </div>

        <div class="prod-toolbar">
          <div class="prod-search-wrap">
            <span class="prod-search-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input class="prod-si" id="prod-search" type="text" placeholder="Buscar por descripción, empresa o ingrediente…">
          </div>
          <select class="prod-fsel" id="prod-cat-filter">
            <option value="">Todas las categorías</option>
          </select>
          <span class="prod-count" id="prod-count"></span>
        </div>

        <div class="prod-tbl-wrap">
          <table class="prod-tbl">
            <thead>
              <tr>
                <th>Descripción</th>
                <th>Categoría</th>
                <th>Tipo / Formulación</th>
                <th>Empresa</th>
                <th>Ingrediente activo</th>
                <th>Unidad</th>
                <th>N° Registro</th>
              </tr>
            </thead>
            <tbody id="prod-tbody"></tbody>
          </table>
        </div>

      </div>
    `;

    this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    const tbody = document.getElementById("prod-tbody");
    if (tbody) tbody.innerHTML = `<tr><td colspan="7" class="prod-empty">Cargando…</td></tr>`;

    this._all = await ProductoListService.instance.get().catch(() => []);
    this._filtered = [...this._all];

    this._populateCategoryFilter();
    this._render();
    this._wireEvents();
  }

  private _populateCategoryFilter(): void {
    const sel = document.getElementById("prod-cat-filter") as HTMLSelectElement | null;
    if (!sel) return;
    const cats = [...new Set(this._all.map((p) => p.categoria).filter(Boolean))].sort((a, b) =>
      a.localeCompare(b),
    );
    for (const cat of cats) {
      const opt = document.createElement("option");
      opt.value = cat;
      opt.textContent = cat;
      sel.appendChild(opt);
    }
  }

  private _wireEvents(): void {
    document.getElementById("prod-search")?.addEventListener("input", () => this._applyFilters());
    document.getElementById("prod-cat-filter")?.addEventListener("change", () => this._applyFilters());
  }

  private _applyFilters(): void {
    const q   = ((document.getElementById("prod-search") as HTMLInputElement | null)?.value ?? "").toLowerCase().trim();
    const cat = ((document.getElementById("prod-cat-filter") as HTMLSelectElement | null)?.value ?? "");

    this._filtered = this._all.filter((p) => {
      const matchCat = !cat || p.categoria === cat;
      const matchQ   = !q || [p.descripcion, p.empresa, p.ingredienteActivo, p.categoria]
        .some((f) => f?.toLowerCase().includes(q));
      return matchCat && matchQ;
    });

    this._render();
  }

  private _render(): void {
    const tbody = document.getElementById("prod-tbody");
    const count = document.getElementById("prod-count");
    if (!tbody) return;

    if (count) {
      count.textContent = `${this._filtered.length} producto${this._filtered.length !== 1 ? "s" : ""}`;
    }

    if (this._filtered.length === 0) {
      tbody.innerHTML = `<tr><td colspan="7"><div class="prod-empty">Sin resultados</div></td></tr>`;
      return;
    }

    tbody.innerHTML = this._filtered
      .map(
        (p) => `<tr>
          <td class="prod-cell-name">${this._esc(p.descripcion)}</td>
          <td><span class="prod-badge prod-badge-cat">${this._esc(p.categoria)}</span></td>
          <td>
            <div>${this._esc(p.tipo)}</div>
            ${p.tipoFormulacion ? `<div><span class="prod-badge prod-badge-tipo">${this._esc(p.tipoFormulacion)}</span></div>` : ""}
          </td>
          <td class="prod-cell-muted">${this._esc(p.empresa)}</td>
          <td class="prod-cell-muted">${this._esc(p.ingredienteActivo)}</td>
          <td class="prod-cell-muted">${this._esc(p.unidadMedida)}</td>
          <td class="prod-cell-mono">${this._esc(p.numeroRegistro)}</td>
        </tr>`,
      )
      .join("");
  }

  private _esc(s: string): string {
    return (s ?? "—")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
}
